import { useEffect, useState } from "react";

function useDebounce(value, delay) {
    const [debouncedVal, setDebouncedVal] = useState(value);

    useEffect(() => {
        const timeoutId = window.setTimeout(() => {
            setDebouncedVal(value);
        }, delay);

        return () => {
            window.clearTimeout(timeoutId);
        }
    }, [value]);

    return debouncedVal;
}

export default useDebounce;